/* Jalecos Mania — abas do localizador de lojas.
   Cada aba mostra o card da loja correspondente. */
(function () {
  document.querySelectorAll('.jm-localizacao').forEach(function (sec) {
    var tabs = sec.querySelectorAll('[data-jm-store-tab]');
    var panels = sec.querySelectorAll('[data-jm-store-panel]');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-jm-store-tab');
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-jm-store-panel') === key);
        });
      });
    });
  });
})();
